module.exports = __webpack_public_path__ + "package1.png?e9304f300c732ffbf4d043891f07675f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/package1.png
// module id = 26
// module chunks = 0